import useDebugConsole from './useDebugConsole'
import styles from './DebugConsole.module.scss'

const DebugConsole = () => {
  const { debug, msg } = useDebugConsole()

  if (!debug) return null

  return (
    <>
      <br />
      {debug && <div className={styles.debugConsoleRoot}>{msg}</div>}
    </>
  )
}

export default DebugConsole
